import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import CloseIcon from "@mui/icons-material/Close";
import { CustomInputField } from "../CommonComponents/CustomCompontes";

const PERMISSION_CONFIG_FE_CONFIG_KEY =
  "hasCompanyConfigurationPermissionEnable";
const OD_DEVICE_RESTORE_FE_CONFIG_KEY = "hasOdRestorationPermissionEnable";
const APPROVER_FE_CONFIG_KEY = "hasExpenseRestorationPermissionEnable";

const initialPermissionOptions = [
  {
    id: 1,
    sfaPermissionName: "OD / Device Restore Access",
    key: OD_DEVICE_RESTORE_FE_CONFIG_KEY,
  },
  {
    id: 2,
    sfaPermissionName: "Expense Approver Access",
    key: APPROVER_FE_CONFIG_KEY,
  },
];

const OdRestorationConfiguration = ({ userList = [], companyId }) => {
  // const companyId =
  // JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
  // JSON.parse(localStorage.getItem("CompanyIdSelect")).id;

  const [odRestoreEmployees, setOdRestoreEmployees] = useState(null);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [allUserAccessControlRes, setAllUserAccessControlRes] = useState(null);
  const [masterUserList, setMasterUserList] = useState([]);
  console.log("user control user list : ", masterUserList);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredPermissionOptions, setFilteredPermissionOptions] = useState(
    [],
  );
  const [userExistingPermission, setUserExistingPermission] = useState([]);
  console.log("filteredPermissionOptions : ", filteredPermissionOptions);
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [permissionInputVal, setPermissionInputVal] = useState("");

  const handleChangeUser = (userVal) => {
    setSelectedUser(userVal);
    setSelectedPermission([]);
    setPermissionInputVal("");
  };

  const handlePermissionChange = (newValue = []) => {
    const hasSelectAll = newValue.some((item) => item?.id === 0);

    setSelectedPermission(
      hasSelectAll ? [...filteredPermissionOptions] : newValue,
    );
  };

  const handleChangeMasterUserList = ({ key = "", index, e }) => {
    console.log(
      "handleChangeMasterUserList : ",
      key,
      index,
      e?.target?.checked,
    );
    if (
      [
        PERMISSION_CONFIG_FE_CONFIG_KEY,
        OD_DEVICE_RESTORE_FE_CONFIG_KEY,
        APPROVER_FE_CONFIG_KEY,
      ].includes(key)
    ) {
      const checked = e?.target?.checked;

      setMasterUserList((prev) => {
        if (!prev?.length || prev[index] == null) return prev;

        const updatedItem = {
          ...prev[index],
          [key]: checked,
          ...(key === PERMISSION_CONFIG_FE_CONFIG_KEY && !checked
            ? {
                [OD_DEVICE_RESTORE_FE_CONFIG_KEY]: false,
                [APPROVER_FE_CONFIG_KEY]: false,
              }
            : {}),
        };

        const updatedArr = [...prev];
        updatedArr[index] = updatedItem;

        return updatedArr;
      });
    }
  };

  const fetchAllOdRestorationEmployees = async () => {
    const response = await companyWiseEmp.getAllOdRestorationEmployee({
      companyId: companyId,
    });

    if (response !== null && response.responseCode === 200) {
      setOdRestoreEmployees(response?.data);
      setSelectedUserIds(response?.data?.userIdList || []);
    }
  };

  const UpdateOdRestorationEmployeeStatus = () => {
    const payload = {
      companyId: companyId ? companyId : null,
      userIdList: selectedUserIds,
    };
    companyWiseEmp.updateOdRestorationEmployee(payload).then((response) => {
      if (response !== null && response?.responseCode == 200) {
        alert(response?.responseDescription);
      } else if (response !== null && response?.responseCode == 400) {
        alert(response?.responseDescription);
      }
    });
  };

  const fetchGetAllUserAccessPermissions = async () => {
    const response = await companyWiseEmp.getAllUserAccessPermissions({
      companyId,
    });

    if (response !== null && response.responseCode === 200) {
      setAllUserAccessControlRes(response?.data);
    }
  };

  const handleSaveUsersAccessPermissions = () => {
    const finalPayload = {
      companyId,
      userPermissionList: masterUserList
        ?.filter((item) => item[PERMISSION_CONFIG_FE_CONFIG_KEY])
        ?.map((filteredItem) => ({
          id: filteredItem?.id,
          [PERMISSION_CONFIG_FE_CONFIG_KEY]:
            filteredItem[PERMISSION_CONFIG_FE_CONFIG_KEY],
          [OD_DEVICE_RESTORE_FE_CONFIG_KEY]:
            filteredItem[OD_DEVICE_RESTORE_FE_CONFIG_KEY],
          [APPROVER_FE_CONFIG_KEY]: filteredItem[APPROVER_FE_CONFIG_KEY],
        })),
    };
    companyWiseEmp.saveUsersAccessPermissions(finalPayload).then((response) => {
      if (response !== null && response?.responseCode == 200) {
        alert(response?.responseDescription);
      } else if (response !== null && response?.responseCode == 400) {
        alert(response?.responseDescription);
      }
    });
  };

  const handleSaveSelectedUserAccessPermission = () => {
    const hasODSelected = selectedPermission?.some(
      (item) => item?.key === OD_DEVICE_RESTORE_FE_CONFIG_KEY,
    );

    const hasApproverSelected = selectedPermission?.some(
      (item) => item?.key === APPROVER_FE_CONFIG_KEY,
    );

    const odValue = hasODSelected
      ? true
      : selectedUser?.[OD_DEVICE_RESTORE_FE_CONFIG_KEY] || false;

    const approverValue = hasApproverSelected
      ? true
      : selectedUser?.[APPROVER_FE_CONFIG_KEY] || false;

    const permissionConfigValue = !!(odValue || approverValue);
    const finalPayload = {
      companyId,
      userPermissionList: [
        {
          id: selectedUser?.id,
          [PERMISSION_CONFIG_FE_CONFIG_KEY]: permissionConfigValue,
          [OD_DEVICE_RESTORE_FE_CONFIG_KEY]: odValue,
          [APPROVER_FE_CONFIG_KEY]: approverValue,
        },
      ],
    };
    companyWiseEmp.saveUsersAccessPermissions(finalPayload).then((response) => {
      if (response !== null && response?.responseCode == 200) {
        alert(response?.responseDescription);
        fetchGetAllUserAccessPermissions();
        // handleChangeUser(null);
      } else if (response !== null && response?.responseCode == 400) {
        alert(response?.responseDescription);
      }
    });
  };

  const handleRemovePermissionForUser = (permissionItem) => {
    if (!selectedUser || !permissionItem?.key) return;

    const removedKey = permissionItem.key;

    const updatedOD =
      removedKey === OD_DEVICE_RESTORE_FE_CONFIG_KEY
        ? false
        : selectedUser?.[OD_DEVICE_RESTORE_FE_CONFIG_KEY] || false;

    const updatedApprover =
      removedKey === APPROVER_FE_CONFIG_KEY
        ? false
        : selectedUser?.[APPROVER_FE_CONFIG_KEY] || false;

    const permissionConfigValue = !!(updatedOD || updatedApprover);

    const finalPayload = {
      companyId,
      userPermissionList: [
        {
          id: selectedUser.id,
          [PERMISSION_CONFIG_FE_CONFIG_KEY]: permissionConfigValue,
          [OD_DEVICE_RESTORE_FE_CONFIG_KEY]: updatedOD,
          [APPROVER_FE_CONFIG_KEY]: updatedApprover,
        },
      ],
    };

    companyWiseEmp.saveUsersAccessPermissions(finalPayload).then((response) => {
      if (response?.responseCode === 200) {
        alert(response.responseDescription);
        fetchGetAllUserAccessPermissions();
      } else {
        alert(response?.responseDescription || "Something went wrong");
      }
    });
  };

  // React.useEffect(() => {
  //   fetchAllOdRestorationEmployees();
  // }, [companyId]);

  useEffect(() => {
    if (companyId) {
      fetchGetAllUserAccessPermissions();
    }
  }, [companyId]);

  useEffect(() => {
    // console.log("cell renders");
    const timer = setTimeout(() => {
      const trimmedTerm = searchTerm.trim().toLowerCase();

      let filtered = [...masterUserList] || [];

      if (trimmedTerm) {
        filtered = filtered?.filter(
          (user) =>
            user?.name?.toLowerCase()?.includes(trimmedTerm) ||
            user?.empCode?.toLowerCase()?.includes(trimmedTerm),
        );
      }

      setFilteredUsersList(filtered);
    }, 200);

    return () => clearTimeout(timer);
  }, [searchTerm, masterUserList]);

  console.log("odRestoreEmployees", odRestoreEmployees);

  useEffect(() => {
    if (Boolean(userList?.length > 0)) {
      setMasterUserList([...userList]);
    } else {
      setMasterUserList([]);
    }
  }, [userList]);

  useEffect(() => {
    if (
      userList?.length > 0 &&
      allUserAccessControlRes?.userPermissionList?.length > 0 &&
      userList?.some(
        (item) => item?.companyId === allUserAccessControlRes?.companyId,
      )
    ) {
      const updatedUsersArr = userList?.map((userListItem, index) => {
        const matchedPermission =
          allUserAccessControlRes?.userPermissionList?.find(
            (permItem) => permItem?.id === userListItem?.id,
          );

        return matchedPermission
          ? { ...userListItem, ...matchedPermission, feIndex: index }
          : { ...userListItem, feIndex: index };
      });

      setMasterUserList([...updatedUsersArr]);
    }
  }, [userList, allUserAccessControlRes]);

  useEffect(() => {
    if (!selectedUser) {
      setFilteredPermissionOptions([...initialPermissionOptions]);
      setUserExistingPermission([]);
      return;
    }

    const newFiltered = [];
    const newExisting = [];

    initialPermissionOptions?.forEach((item) => {
      const isSpecial =
        item?.key &&
        [OD_DEVICE_RESTORE_FE_CONFIG_KEY, APPROVER_FE_CONFIG_KEY].includes(
          item.key,
        );

      if (isSpecial && selectedUser?.[item.key] === true) {
        newExisting.push(item);
      } else {
        newFiltered.push(item);
      }
    });

    setFilteredPermissionOptions(newFiltered);
    setUserExistingPermission(newExisting);
  }, [selectedUser, initialPermissionOptions]);

  useEffect(() => {
    if (
      selectedUser &&
      typeof selectedUser.feIndex === "number" &&
      masterUserList?.length > 0
    ) {
      const updatedUser = masterUserList[selectedUser.feIndex];

      // 🔥 important: reference change
      if (updatedUser && updatedUser !== selectedUser) {
        handleChangeUser(updatedUser);
      }
    }
  }, [masterUserList, selectedUser]);

  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <h3
            style={{
              color: "#fff",
              marginLeft: "10px",
              padding: "10px 2px",
            }}
          >
            User Access Control:-
          </h3>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className="accoardian_body">
        <Box sx={{ my: 1, py: 1, px: 1 }}>
          <Grid container direction="row" alignItems="center" spacing={3}>
            {/* <Grid item spacing={3} xs={3}>
              <CustomInputField
                sx={{ margin: "0px !important" }}
                value={searchTerm}
                label="Search "
                variant="outlined"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Grid> */}
            {/* <Grid item spacing={3} xs={9}></Grid> */}
            {/* <Grid item xs={12}>
              <TableContainer
                component={Paper}
                sx={{ maxHeight: "450px", overflow: "auto" }}
              >
                <Table size="small" aria-label="a dense table" stickyHeader>
                  <TableHead
                  // style={{ color: "#fff", backgroundColor: "#32577e" }}
                  >
                    <TableRow>
                      <TableCell
                        className="tabalecellStyle"
                        sx={{ bgcolor: "#32577e", color: "#fff" }}
                      >
                        S.no
                      </TableCell>
                      <TableCell
                        className="tabalecellStyle"
                        sx={{ bgcolor: "#32577e", color: "#fff" }}
                      >
                        Employee Name
                      </TableCell>
                      <TableCell
                        className="tabalecellStyle"
                        sx={{ bgcolor: "#32577e", color: "#fff" }}
                      >
                        Permission Configuration Access
                      </TableCell>
                      <TableCell
                        className="tabalecellStyle"
                        sx={{ bgcolor: "#32577e", color: "#fff" }}
                      >
                        OD / Device Restore Access
                      </TableCell>
                      <TableCell
                        className="tabalecellStyle"
                        sx={{ bgcolor: "#32577e", color: "#fff" }}
                      >
                        Expense Approver Access
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredUsersList &&
                      filteredUsersList.map((val, ind) => {
                        return (
                          <>
                            <TableRow>
                              <TableCell>{ind + 1}</TableCell>
                              <TableCell>
                                {val?.name}({val?.empCode})
                              </TableCell>
                              <TableCell>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          val[
                                            PERMISSION_CONFIG_FE_CONFIG_KEY
                                          ] || false
                                        }
                                        onChange={(e) =>
                                          handleChangeMasterUserList({
                                            key: PERMISSION_CONFIG_FE_CONFIG_KEY,
                                            index: val?.feIndex,
                                            e,
                                          })
                                        }
                                      />
                                    }
                                  />
                                </FormGroup>
                              </TableCell>
                              <TableCell>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        disabled={
                                          !val[
                                            PERMISSION_CONFIG_FE_CONFIG_KEY
                                          ] || false
                                        }
                                        checked={
                                          val[
                                            OD_DEVICE_RESTORE_FE_CONFIG_KEY
                                          ] || false
                                        }
                                        onChange={(e) =>
                                          handleChangeMasterUserList({
                                            key: OD_DEVICE_RESTORE_FE_CONFIG_KEY,
                                            index: val?.feIndex,
                                            e,
                                          })
                                        }
                                      />
                                    }
                                  />
                                </FormGroup>
                              </TableCell>
                              <TableCell>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        disabled={
                                          !val[
                                            PERMISSION_CONFIG_FE_CONFIG_KEY
                                          ] || false
                                        }
                                        checked={
                                          val[APPROVER_FE_CONFIG_KEY] || false
                                        }
                                        onChange={(e) =>
                                          handleChangeMasterUserList({
                                            key: APPROVER_FE_CONFIG_KEY,
                                            index: val?.feIndex,
                                            e,
                                          })
                                        }
                                      />
                                    }
                                  />
                                </FormGroup>
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid> */}
            <Grid item>
              <div className="field_box">
                <Autocomplete
                  size="small"
                  className="select_box_forCompanyWise"
                  limitTags={1}
                  id="multiple-limit-tags"
                  options={masterUserList}
                  getOptionLabel={(option) =>
                    `${option.name}(${option.empCode})`
                  }
                  disablePortal={true}
                  fullWidth
                  onChange={(event, newValue) => handleChangeUser(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="User"
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid item>
              <div className="field_box">
                <Autocomplete
                  size="small"
                  multiple
                  className="select_box_forCompanyWise"
                  limitTags={1}
                  id="multiple-limit-tags"
                  options={[
                    { id: 0, sfaPermissionName: "Select All" },
                    ...filteredPermissionOptions,
                  ]}
                  getOptionLabel={(option) => `${option.sfaPermissionName}`}
                  disablePortal={true}
                  fullWidth
                  filterSelectedOptions
                  value={selectedPermission}
                  onChange={(event, newValue) =>
                    handlePermissionChange(newValue)
                  }
                  inputValue={permissionInputVal}
                  onInputChange={(event, newVal) => {
                    setPermissionInputVal(newVal);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="Permissions"
                    />
                  )}
                />
              </div>
            </Grid>
            {/* {Boolean(selectedPermission?.length) && ( */}
            <Grid item>
              <div className="field_box">
                <Button
                  className="field_box_btn1"
                  // onClick={savePermissionForUser}
                  onClick={() => handleSaveSelectedUserAccessPermission()}
                  sx={{
                    cursor: "pointer",
                    color: "#fff",
                    textTransform: "none",
                  }}
                >
                  Save
                </Button>
              </div>
            </Grid>
            {/* )} */}
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {userExistingPermission?.map((item, index) => {
                  return (
                    <Box
                      // key={item.id}
                      key={index}
                      sx={{
                        backgroundColor: "#E0DCD6",
                        p: 1.3,
                        borderRadius: 5,
                      }}
                    >
                      {item?.sfaPermissionName}
                      <IconButton
                        sx={{ p: 0.4, color: "crimson" }}
                        onClick={() => handleRemovePermissionForUser(item)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
          {/* <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={() => handleSaveUsersAccessPermissions()}
                style={{
                  cursor: "pointer",
                  width: "60px",
                }}
              >
                Save
              </div>
            </div>
          </Box> */}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default OdRestorationConfiguration;
